(function ($) {
    $(document).ready(function () {
        if ($('.research-team').length > 0) {
            setTimeout(function () {
                $(".research-team .col-outer").css({
                    "opacity": "1"
                });
            }, 500);

            if ($('body .research-team .col-outer .item-outer').length > 2) {
                $('.research-team .col-outer').slick({
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    dots: false,
                    arrows: true,
                    infinite: false,
                    cssEase: 'linear',
                    responsive: [{
                        breakpoint: 991,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                        }
                    },
                        {
                            breakpoint: 767,
                            settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1,
                                draggable: true
                            }
                        }
                    ]
                });
                $(document).on('click', '.research-team .slick-prev', function () {
                    dataLayer.push({
                        event: 'research_team_slider_arrow_click',
                        event_category: 'Research Team Slider Card Arrow Click',
                        event_label: 'Research Team Slider Card Previous Arrow',
                        page_url: 'research team page'
                    });
                });
                $(document).on('click', '.research-team .slick-next', function () {
                    dataLayer.push({
                        event: 'research_team_slider_arrow_click',
                        event_category: 'Research Team Slider Card Arrow Click',
                        event_label: 'Research Team Slider Card Next Arrow',
                        page_url: 'research team page'
                    });
                });
            }
        }
    });
})(jQuery);